<main class="verificacion-documento">
  <header class="verificacion-cabecera">
    <img src="assets/logo.png" alt="Acteco">
    <strong>Documento de transporte</strong>
  </header>
  <section class="verificacion-tarjeta" [class.error]="!cargando && !valido">
    <div *ngIf="cargando" class="estado">
      <div class="spinner" aria-hidden="true"></div>
      <h1>Abriendo documento</h1>
      <p>Estamos comprobando el enlace seguro.</p>
    </div>
    <div *ngIf="!cargando && valido" class="documento">
      <h1>{{ nombreDocumento }}</h1>
      <p role="status">La descarga del documento se ha iniciado.</p>
    </div>
    <div *ngIf="!cargando && !valido" class="estado">
      <h1>Documento no disponible</h1>
      <p role="alert">{{ mensajeError }}</p>
    </div>
  </section>
</main>
